// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

export const StoneImageFragmentDoc = `
    fragment StoneImage on GemsApi_StoneImage {
  __typename
  url
  isB2B
}
    `;